<template>
  <div class="row">
    <div class="col-md-8">
      <h3>Monthly Budget</h3> 
    </div>
    <div class="col-md-2 offset-md-2">
      <router-link :to="{ name: 'Add Budget'}" style="float:right">
        <p-button type="primary" round>
          Add Budget
        </p-button>
      </router-link>
    </div>


    <div class="col-md-12">
      <card>
        <bar-chart 
          v-if="loaded"
          :labels="budgetChart.labels"
                    :height="150"
                    :extra-options="budgetChart.options"
                    :datasets="budgetChart.datasets">
        </bar-chart>
      </card>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          
          <div class="col-sm-12">
            <div class="card" v-for="(data, index) in queriedData" :key="index">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-3" style="padding-top:18px;"><strong>{{data.name}}</strong></div>
                  <div class="col-md-3" style="padding-top:18px;">{{data.amount}}</div>
                  
                  <div class="col-md-3">
                    <router-link :to="{ name: 'Update Budget', params: { id: data.id }}">
                      <p-button type="success" icon>
                        <i class="fa fa-edit"></i>
                      </p-button>
                    </router-link>
                    <p-button type="danger"  icon @click="handleDelete(index, data)">
                      <i class="fa fa-times"></i>
                    </p-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from 'src/components/UIComponents'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  import BarChart from 'src/components/UIComponents/Charts/HorizontalBarChart'
 

  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
  };
  export default {
    components: {
      Card,
      BarChart,
      PPagination
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data() {
      return {
        loaded: false,

        model: {
          labels: []
        },
        budgetChart: {
          
          datasets: [
            {
              label: "Budget",
              borderColor: '#4cbdd7',
              fill: true,
              backgroundColor: '#4cbdd7',
              hoverBorderColor: '#4cbdd7',
              borderWidth: 3,
              data: [],
            },
            {
              label: "Spent",
              borderColor: '#ef8157',
              fill: true,
              backgroundColor: '#ef8157',
              hoverBorderColor: '#ef8157',
              borderWidth: 3,
              data: [],
            }
          ],
          options: {
            tooltips: tooltipOptions,
            legend: {
              display: true
            },
            scales: {
              yAxes: [{
                ticks: {
                 
                  beginAtZero: true,
                  
                },
                gridLines: {
                  
                  display: true,
                  drawBorder: false,
                  color: '#9f9f9f',
                }

              }],
              xAxes: [{
                barPercentage: 0.4,
                gridLines: {
                 
                  display: true,
                  
                },
                ticks: {
                  
                  beginAtZero: true,
                  
                }
              }]
            }
          }
        },
        
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['category', 'amount'],
        tableColumns: [
          {
            prop: 'name',
            label: 'Category',
            minWidth: 200
          },
          {
            prop: 'amount',
            label: 'Amount (₦)',
            minWidth: 100
          },
        ],
        tableData: []
      }
    },
    methods: {

      handleDelete (index, row) {
        this.$http.delete('/budgets/' + row.id)
        .then(response=>{

          let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
          if (indexToDelete >= 0) {
            this.tableData.splice(indexToDelete, 1)
          }

        })
        .catch(error =>{
          //what to do when there is an error with the registration
          
          console.log(error)
        })
      },

      getBudget () {
        this.$http.get('/budgets')
        .then(response => {
          

          if(response.data.length == 0 ) {
            return
          }

          let budgetData = response.data
          let budgetChartLabels = []
          let budgetedAmount = []

          for (let key = 0; key < budgetData.length; key++) {

           budgetChartLabels[key] = budgetData[key]['name']
           budgetedAmount[key] = budgetData[key]['amount'] / 100
          }

          this.budgetChart.labels = budgetChartLabels
          this.budgetChart.datasets[0]['data'] = budgetedAmount 
          this.loaded = true

          response.data.map(function (e) {
            e.amount = new Intl.NumberFormat('en-US', 
                { style: 'currency', currency: 'NGN' }).format(e.amount / 100).replace('NGN', '₦')
          });

          this.tableData = response.data
          
        })
        .catch(error => {
          
        })
      }
    },

    async mounted () {
      this.getBudget()
    }
  }
</script>
<style lang="scss">
  .el-table .td-actions{
    button.btn {
      margin-right: 5px;
    }
  }
</style>
